import { useEffect, useState } from 'react';
import { analyticsConfigured, getConsent, setConsent, loadAnalytics } from '../lib/analytics';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!analyticsConfigured()) return;
    const consent = getConsent();
    if (consent === 'accepted') {
      loadAnalytics();
    } else if (!consent) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const choose = (value) => {
    setConsent(value);
    if (value === 'accepted') loadAnalytics();
    setVisible(false);
  };

  return (
    <div
      role="region"
      aria-label="Cookie consent"
      data-testid="cookie-banner"
      className="fixed bottom-20 left-4 right-4 z-50 rounded-2xl border border-charcoal-line bg-charcoal-deep p-5 text-offwhite shadow-2xl sm:bottom-6 sm:left-auto sm:right-6 sm:max-w-sm lg:bottom-6"
    >
      <p className="text-sm leading-relaxed text-offwhite/80">
        We’d like to use analytics cookies to understand how the site is used. They’re optional — the site works
        exactly the same without them.
      </p>
      <div className="mt-4 flex gap-3">
        <button
          type="button"
          onClick={() => choose('accepted')}
          data-testid="cookie-accept"
          className="flex-1 rounded-full bg-lime py-2.5 text-sm font-semibold text-charcoal transition-colors hover:bg-lime-hover"
        >
          Accept
        </button>
        <button
          type="button"
          onClick={() => choose('declined')}
          data-testid="cookie-decline"
          className="flex-1 rounded-full border border-offwhite/30 py-2.5 text-sm font-semibold text-offwhite transition-colors hover:bg-offwhite/10"
        >
          Decline
        </button>
      </div>
    </div>
  );
}
